import React from 'react';
import './Navigation.css';

const Navigation = () => {
  const isLandscapeMobile = window.innerWidth <= 1024 && window.innerHeight < window.innerWidth;

  return (
    <nav className="navigation">
      <div className="nav-container">
        <div className="nav-brand">
          <img src={"/핫소스_AnyMaking.png?v=" + Date.now()} alt="핫소스" className="nav-logo" />
        </div>
        {!(isLandscapeMobile) && (
          <div className="nav-menu">
            <a href="#home" className="nav-link">홈</a>
            <a href="#members" className="nav-link">멤버</a>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
